var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.20047 13.6313C6.20042 13.7584 6.23402 13.8831 6.29752 13.9912C6.36102 14.0994 6.45191 14.1868 6.55997 14.2436L7.86015 14.9278C7.95929 14.98 8.06944 15.0046 8.18015 14.9993C8.29086 14.994 8.39845 14.959 8.4927 14.8977C8.58696 14.8363 8.66474 14.7506 8.71867 14.6487C8.7726 14.5468 8.80088 14.4321 8.80083 14.3155V9.52613C8.80097 9.18703 8.92074 8.86007 9.13692 8.60863L13.8325 3.1426C13.9167 3.04446 13.972 2.92276 13.9918 2.79222C14.0117 2.66167 13.9952 2.52788 13.9443 2.40701C13.8934 2.28614 13.8103 2.18338 13.7051 2.11115C13.5999 2.03892 13.4771 2.00031 13.3514 2H1.64985C1.52413 2.00005 1.40112 2.03846 1.29572 2.11059C1.19032 2.18272 1.10705 2.28547 1.056 2.40639C1.00495 2.52731 0.988315 2.66121 1.0081 2.79188C1.02789 2.92255 1.08325 3.04438 1.16749 3.1426L5.86438 8.60863C6.08056 8.86007 6.20033 9.18703 6.20047 9.52613V13.6313Z",
    stroke: "#0A0A0A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.97f62f1f00df6b8c26d98ff891dd9915.svg";
export { ForwardRef as ReactComponent };